<template>
  <el-table :data='value' class="lot-list">
    <el-table-column label="样本接收单号" prop="batchNum" min-width="81">
    </el-table-column>
    <el-table-column label="客户名称" prop="clientOrganization.name" min-width="85"></el-table-column>
    <!-- <el-table-column label="送检人" prop="senders" min-width="60">
			<template slot-scope="scope">
				{{scope.row.senders ? scope.row.senders.toString() : ''}}
			</template>
		</el-table-column> -->
    <el-table-column label="订单数" min-width="60">
      <template slot-scope="scope">
        {{scope.row.orderSize}}
      </template>
    </el-table-column>
    <el-table-column label="样本回寄" min-width="72">
      <template slot-scope="scope">
        <i class="el-icon-check" v-if="scope.row.waitingSampleReturn=='COMPLETED'"></i>
        <span v-else-if="scope.row.waitingSampleReturn == ''"></span>
        <span class="operate-btn" v-else @click="doPrecess(scope.row.batchNum, scope.row.batchNum,'SAMPLE_RETURNED', scope.row.waitingSampleReturn)">{{scope.row.waitingCreate ? scope.row.waitingSampleReturn.split('/')[1] :''}}</span>
      </template>
    </el-table-column>
    <el-table-column label="样本接收" min-width="72">
      <template slot-scope="scope">
        <i class="el-icon-check" v-if="scope.row.unreceived=='COMPLETED'"></i>
        <span v-else-if="scope.row.unreceived == ''"></span>
        <span v-else>{{scope.row.waitingCreate ? scope.row.unreceived.split('/')[1] :''}}</span>
      </template>
    </el-table-column>
    <el-table-column label="样本提取" min-width="72">
      <template slot-scope="scope">
        <i class="el-icon-check" v-if="scope.row.unchecked=='COMPLETED'"></i>
        <span v-else-if="scope.row.unchecked == ''"></span>
        <span v-else>{{scope.row.waitingCreate ? scope.row.unchecked.split('/')[1] :''}}</span>
      </template>
    </el-table-column>
    <el-table-column label="检测实验" min-width="72">
      <template slot-scope="scope">
        <i class="el-icon-check" v-if="scope.row.uncheckedDNA=='COMPLETED'"></i>
        <span v-else-if="scope.row.uncheckedDNA == ''"></span>
        <span v-else>{{scope.row.waitingCreate ? scope.row.uncheckedDNA.split('/')[1] :''}}</span>
      </template>
    </el-table-column>
    <el-table-column label="报告生成" min-width="72">
      <template slot-scope="scope">
        <i class="el-icon-check" v-if="scope.row.waitingReportCreate=='COMPLETED'"></i>
        <span v-else-if="scope.row.waitingReportCreate == ''"></span>
        <span v-else>{{scope.row.waitingReportCreate ? scope.row.waitingReportCreate.split('/')[1] :''}}</span>
      </template>
    </el-table-column>
    <el-table-column label="报告审核" min-width="72">
      <template slot-scope="scope">
        <i class="el-icon-check" v-if="scope.row.unReviewed1st=='COMPLETED'"></i>
        <span v-else-if="scope.row.unReviewed1st == ''"></span>
        <span v-else>{{scope.row.unReviewed1st ? scope.row.unReviewed1st.split('/')[1] :''}}</span>
      </template>
    </el-table-column>
    <slot />
  </el-table>
</template>
<script>
/**
 * 批次内的订单视图
 */
export default {
  name: 'lots-list',
  props: {
    value: {
      type: Array,
      required: true
    }
  }
}
</script>
